let WS_URL = null;
let BASEURL = '';
let DESA = 'Mopait';
let KECAMATAN = 'lolayan';
let GOOGLE_ID = process.env.REACT_APP_GOOGLEID;
let FACEBOOK_ID = process.env.REACT_APP_FACEBOOKID;
let NEXTURL = '';

if (process.env.NODE_ENV === 'development') {
	WS_URL = 'http://localhost/wskada/ws/'; //WEBSERVICE URL
	BASEURL = 'https://localhost:3000/';
	NEXTURL = 'https://news.mopait.desadigital.site/';
} else {
	WS_URL = 'https://warta9bmr.com/realcount/'; //WEBSERVICE URL
	BASEURL = 'https://mopait.desadigital.site/';
	NEXTURL = 'https://news.mopait.desadigital.site/';
}

let REST_KEY = process.env.REACT_APP_RESTKEY; //key rest api

export { WS_URL, REST_KEY, GOOGLE_ID, BASEURL, DESA, KECAMATAN, FACEBOOK_ID, NEXTURL };
